var exports = {
  "TQ": "Checkbox.module__checkboxWrapper___WTRyb1",
  "r9": "Checkbox.module__disabled___WTRyb1",
  "iD": "Checkbox.module__menuDisabled___WTRyb1",
  "kv": "Checkbox.module__checkbox___WTRyb1",
  "aP": "Checkbox.module__box___WTRyb1",
  "LI": "Checkbox.module__round___WTRyb1",
  "KD": "Checkbox.module__checked___WTRyb1",
  "NX": "Checkbox.module__checkedInverted___WTRyb1",
  "e_": "Checkbox.module__inverted___WTRyb1",
  "oE": "Checkbox.module__checkIcon___WTRyb1",
  "HN": "Checkbox.module__invertedIcon___WTRyb1",
  "Pf": "Checkbox.module__label___WTRyb1",
  "hJ": "Checkbox.module__labelInteractive___WTRyb1",
  "QK": "Checkbox.module__labelText___WTRyb1",
  "GR": "Checkbox.module__keyboardShortcut___WTRyb1",
  "RA": "Checkbox.module__keyboardShortcutKey___WTRyb1",
  "wf": "Checkbox.module__keyboardShortcutLabel___WTRyb1",
  "xB": "Checkbox.module__keyboardShortcutHint___WTRyb1",
  "wP": "Checkbox.module__keyboardShortcutPortal___WTRyb1",
  "nV": "Checkbox.module__labelFocusRing___WTRyb1",
  "P8": "Checkbox.module__menuChecked___WTRyb1",
  "fb": "Checkbox.module__checkboxIndicator___WTRyb1",
};

module.exports = exports;
